const types = {
    SUBMIT_REQUEST: 'SUBMIT_REQUEST',
    ERROR_ENCOUNTERED: 'ERROR_ENCOUNTERED',
    COMPLETE_REQUEST: 'COMPLETE_REQUEST',
    SET_USER_LOCATION: 'SET_USER_LOCATION',
    ADD_STORE_DETAILS: 'ADD_STORE_DETAILS',
    SET_SELECTED_STORE: 'SET_SELECTED_STORE',
    AVAILABILITY: 'AVAILABILITY',
    STORE_SEARCH: 'STORE_SEARCH'
};
export default types;
